module.exports = __webpack_public_path__ + "img/local-5.2d9416fc.jpg";